export default __webpack_public_path__ + "static/media/manana-onn.5f17533f.svg";